import React, { useEffect } from "react";
import "./aboutUs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faTshirt, faHeart } from "@fortawesome/free-solid-svg-icons";
import aboutUsImage from "../../assets/images/about-us.jpg"
import { Helmet } from "react-helmet";


export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | About Us - Who We Are</title>
        <meta
          name="description"
          content="Learn more about SHOP.CO, our mission, and our commitment to providing you with the best shopping experience online."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/company/about-us/"
        />
      </Helmet>

      <div className="aboutUs-page">
        <div className="aboutUs-hero">
          <img
            src={aboutUsImage}
            alt="Fashion"
            className="aboutUs-hero-image"
          />
          <div className="aboutUs-hero-text">
            <h1>About Shop.Co</h1>
            <p>Your style. Your story. Our passion.</p>
          </div>
        </div>

        <div className="aboutUs-content">
          <h2>Who We Are</h2>
          <p>
            Shop.Co is more than just an online store. We are a team of passionate creators,
            designers, and fashion enthusiasts who believe in the power of self-expression through clothing.
            Our goal is to bring you the latest trends with high quality and affordable prices.
          </p>

          <div className="aboutUs-features">
            <div className="aboutUs-feature">
              <FontAwesomeIcon icon={faUsers} className="aboutUs-icon" />
              <h3>Community Driven</h3>
              <p>We grow with our loyal customers and believe in authentic connections.</p>
            </div>
            <div className="aboutUs-feature">
              <FontAwesomeIcon icon={faTshirt} className="aboutUs-icon" />
              <h3>Trendy Designs</h3>
              <p>We handpick and design modern outfits for every occasion.</p>
            </div>
            <div className="aboutUs-feature">
              <FontAwesomeIcon icon={faHeart} className="aboutUs-icon" />
              <h3>Made with Love</h3>
              <p>Every product we create is crafted with care and attention to detail.</p>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
